var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2890_3079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2890_3079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 42L24 4L46 42H2ZM24.2087 36.15C24.6362 36.15 24.9917 36.0054 25.275 35.7163C25.5583 35.4271 25.7 35.0687 25.7 34.6413C25.7 34.2138 25.5554 33.8583 25.2663 33.575C24.9771 33.2917 24.6187 33.15 24.1913 33.15C23.7638 33.15 23.4083 33.2946 23.125 33.5837C22.8417 33.8729 22.7 34.2313 22.7 34.6588C22.7 35.0863 22.8446 35.4417 23.1337 35.725C23.4229 36.0083 23.7813 36.15 24.2087 36.15ZM22.7 30.6H25.7V19.4H22.7V30.6Z",
    fill: "#FF7A7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning_triangle.0bbdb8335f496fe58ae8c92c6a6f37e2.svg";
export { ForwardRef as ReactComponent };